import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, A11y } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import Team1Image from "../../assets/images/Jitesh.png";
import Team2Image from "../../assets/images/sachinnarang.png";
import Team3Image from "../../assets/images/Smiten.png";
import Team4Image from "../../assets/images/Simran.png";

const OurTeamCarousel = () => {
    const teamMembers = [
        {
            id: 1,
            name: "Jitesh Narang",
            designation: "Founder & Tech Marketing Head",
            image: Team1Image,
        },
        {
            id: 2,
            name: "Sachin Narang",
            designation: "Operations & Production Head",
            image: Team2Image,
        },
        {
            id: 3,
            name: "Smiten",
            designation: "Full Stack Developer",
            image: Team3Image,
        },
        {
            id: 4,
            name: "Simran Nandwani",
            designation: "Business Manager",
            image: Team4Image,
        },
    ];

    return (
        <>
        <Swiper
            modules={[Navigation, Pagination, A11y]}
            spaceBetween={18}
            slidesPerView={5} // Show 3 slides at a time
            navigation
            pagination={{ clickable: true }}
            loop={true}
            breakpoints={{
                320: {
                    slidesPerView: 1.5,
                },
                676: {
                    slidesPerView: 2,
                },
                776: {
                    slidesPerView: 3,
                },
                1200: {
                    slidesPerView: 4,
                },
            }}
        >
            {teamMembers.map((member) => (
                <SwiperSlide key={member.id}>
                    <div className="team-box">
                        <div className="img-wrapper">
                            <img src={member.image} alt={member.name} />
                        </div>

                        <div className="content">
                            <h5 className="fs_24 lh-1 fw_600 mb_10 text-color">
                                {member.name}
                            </h5>

                            <p className="fs_16 lh-1 fw_400 mb_10 text-color">
                                {member.designation}
                            </p>
                        </div>
                    </div>
                </SwiperSlide>
            ))}
        </Swiper>
        </>
    );
};

export default OurTeamCarousel;